import api from "../services/api";
import chatbotApi from "../services/chatbotApi";

export const loadEndpointWithPagination = async (endpoint, sizeReceived, isChatbotCatalog) => {
  const currentApi = isChatbotCatalog ? chatbotApi : api;
  let page = 1;
  let size = sizeReceived || 50;
  let allResults = [];
  let hasMore = true;

  while (hasMore) {
    const response = await currentApi.get(`${endpoint}?page=${page}&size=${size}`);
    const { data, totalPages } = response.data.response;

    if (page > totalPages) break;

    allResults = allResults?.concat(data);
    hasMore = data?.length === size;
    page++;
  };

  return allResults;
}